import { Box, CircularProgress, Container, FormControl, Button, FormControlLabel, Grid, InputAdornment, InputLabel, MenuItem, Paper, Radio, RadioGroup, Select, Stack, TextField, Typography, IconButton, FormGroup, Checkbox, Backdrop } from '@mui/material'
import React, { useEffect, useReducer, useRef, useState } from 'react'
import dayjs from 'dayjs';
import CropOriginalIcon from '@mui/icons-material/CropOriginal';
import CampaignIcon from '@mui/icons-material/Campaign';
import AddIcon from '@mui/icons-material/Add';
import CloseIcon from '@mui/icons-material/Close';
import { useSettingsContext } from '../../../components/settings';
import postUploadImage from '../../../services/campian/uploadImage';
import { useAuthContext } from '../../../auth/useAuthContext';
import { notify } from '../../../components/notify';
import FormatBoldIcon from '@mui/icons-material/FormatBold';
import FormatItalicIcon from '@mui/icons-material/FormatItalic';
import getCampianCategory from '../../../services/campian/getCategory';
import getCampianLanguages from '../../../services/campian/getLanguages';
import { useCampaignTemplateContext } from 'src/contexts/CampaignTemplateContext';
import CustomInput from 'src/components/customerinput/CustomerInput';
import CallIcon from '@mui/icons-material/Call';
import LaunchIcon from '@mui/icons-material/Launch';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useLocation, useNavigate } from 'react-router';
import updateTemplate from 'src/services/campian/updateTemplate';
import { LoadingButton } from '@mui/lab';
import getCampianAssignVendorGroups from 'src/services/campian/getAssignGroupDataVendor';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { EmojiEmotions } from "@mui/icons-material";
import EmojiPicker from 'emoji-picker-react';
import useModalControl from 'src/components/cards/useModalControl';
import createCampaignTemplateDefault from 'src/services/campian/createTemplateDefault';
import ReplyIcon from '@mui/icons-material/Reply';
const reducer = (state, { type, payload }) => {
    switch (type) {
        case 'vendorType':
            return {
                ...state,
                vendorType: payload

            }
        case 'meta_acc_id':
            return {
                ...state,
                meta_acc_id: payload

            }
        case 'vendorId':
            return {
                ...state,
                vendorId: payload

            }
        case 'name':
            return {
                ...state,
                name: payload?.trimStart()

            }
        case 'language':
            return {
                ...state,
                language: payload

            }
        case 'template':
            return {
                ...state,
                template: payload

            }
        case 'phone_number':
            return {
                ...state,
                phone_number: payload

            }
        case 'header.format':
            return {
                ...state,
                header: { ...state?.header, format: payload?.trimStart() }
            }
        case 'body.example.header_text':
            return {
                ...state,
                body: { ...state?.body, example: { ...state?.body?.example, header_text: payload?.trimStart() } }
            }
        case 'header.example.header_text':
            return {
                ...state,
                header: { ...state?.header, example: { ...state?.header?.example, header_text: payload?.trimStart() } }
            }
        case 'header.example.header_handle':
            return {
                ...state,
                header: { ...state?.header, example: { ...state?.header?.example, header_handle: payload } }
            }
        case 'header.example?.type':
            return {
                ...state,
                header: { ...state?.header, example: { ...state?.header?.example, type: payload } }
            }
        case 'header.example?.dynamic_Key':
            return {
                ...state,
                header: { ...state?.header, example: { ...state?.header?.example, dynamic_Key: payload?.trimStart() } }
            }
        case 'header.example?.display_name':
            return {
                ...state,
                header: { ...state?.header, example: { ...state?.header?.example, display_name: payload?.trimStart() } }
            }
        case 'body.example?.type':
            return {
                ...state,
                body: { ...state?.body, example: { ...state?.body?.example, type: payload } }
            }
        case 'header.text': {
            return {
                ...state,
                header: { ...state?.header, text: payload?.trimStart() },
                headerError: validateInput(payload?.trimStart())
            }
        }
        case 'body.text': {
            return {
                ...state,
                body: { ...state?.body, text: payload?.trimStart() },
            }
        }
        case 'bodyplaceholder': {
            return {
                ...state,
                bodyplaceholder: payload,
            }
        }
        case 'bodyError': {
            return {
                ...state,
                bodyError: payload,
            }
        }
        case 'footerText': {
            return {
                ...state,
                footerText: payload?.trimStart(),
            }
        }
        case 'assign_number': {
            return {
                ...state,
                assign_number: payload,
            }
        }
        case 'selectedImage': {
            return {
                ...state,
                selectedImage: payload,
            }
        }
        case 'template_feilds': {
            return {
                ...state,
                template_feilds: payload,
            }
        }
        case 'visiteButton': {

            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            status: payload?.checked
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.text': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            text: payload?.text?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.display_name': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            display_name: payload?.text?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.type': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            type: payload?.type,
                            url: payload?.type == 'STATIC' ? "https://ticketsque.com" : "https://ticketsque.com/{{1}}",
                            text: payload?.type == 'STATIC' ? "Visit website" : it.text
                        }
                    }
                    return it
                }),
            }
        }
        // case 'visiteButton.type': {
        //     return {
        //         ...state,
        //         visiteButton: state?.visiteButton?.map((it, index) => {
        //             if (index == payload?.index) {
        //                 return {
        //                     ...it,
        //                     type: payload?.type
        //                 }
        //             }
        //             return it
        //         }),
        //     }
        // }
        case 'visiteButton.dynamic_Key': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            dynamic_Key: payload?.dynamic_Key?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.url': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            url: payload?.url?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.code': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            code: payload?.code?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.phone_number': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            phone_number: payload?.phone_number?.trimStart()
                        }
                    }
                    return it
                }),
            }
        }
        case 'visiteButton.example.header_text': {
            return {
                ...state,
                visiteButton: state?.visiteButton?.map((it, index) => {
                    if (index == payload?.index) {
                        return {
                            ...it,
                            example: { header_text: payload?.header_text?.trimStart() }
                        }
                    }
                    return it
                }),
            }
        }
        case 'bodyplaceholder.value': {

            return {
                ...state,
                bodyplaceholder: state.bodyplaceholder?.map(item =>
                    item.key === payload.key ? { ...item, value: payload.value?.trimStart() } : item
                )
            }
        }
        case 'bodyplaceholder.type': {
            return {
                ...state,
                bodyplaceholder: state.bodyplaceholder?.map(item =>
                    item.key === payload.key ? {
                        ...item,
                        type: payload.type,
                        value: "",
                        dynamic_Key: payload.type == 'STATIC' ? "" : item?.dynamic_Key,

                    } : item
                )
            }
        }
        case 'bodyplaceholder.dynamic_Key': {
            const dynamicValue = state?.template_feilds.find((it) => it?._id == payload.dynamic_Key)
            let name = ""
            if (dynamicValue.handle == "customer-name") {
                name = "guest"
            } else {
                name = "vendor"
            }

            return {
                ...state,
                bodyplaceholder: state.bodyplaceholder?.map(item =>
                    item.key === payload.key ? { ...item, dynamic_Key: payload.dynamic_Key?.trimStart(), value: name } : item
                )
            }
        }
        case 'bodyplaceholder.display_name': {
            return {
                ...state,
                bodyplaceholder: state.bodyplaceholder?.map(item =>
                    item.key === payload.key ? { ...item, display_name: payload.display_name?.trimStart() } : item
                )
            }
        }
        case 'header.text.variable':
            return {
                ...state,
                header: { ...state?.header, text: state?.header?.text ? `${state?.header?.text} {{1}}` : '{{1}}' }
            }
        case 'template_status':
            return {
                ...state,
                template_status: payload
            }
        case 'body.text.variable': {
            const variablePattern = /\{\{(\d+)\}\}/g;
            let matches = [...state?.body?.text?.matchAll(variablePattern)].map((m) => parseInt(m[1]));
            let nextNumber = matches.length > 0 ? Math.max(...matches) + 1 : 1;
            let newText = state?.body?.text + ` {{${nextNumber}}}`;

            return {
                ...state,
                body: { ...state?.body, text: newText },
                bodyError: validateMessage(newText)
            }
        }
        case 'edit': {
            const { category, language, meta_acc_id, name, components, variables, meta_template_id, vendor, meta_phone_number_id, active } = payload
            const variableBody = JSON.parse(variables)?.body
            const variableButtons = JSON.parse(variables)?.button
            let header = components.find((it) => it?.type == 'HEADER')
            let body = components.find((it) => it?.type == 'BODY')
            let button = components.find((it) => it?.type == 'BUTTONS')
            if (button?.buttons?.length) {
                button = button?.buttons.map((it) => {
                    const check = variableButtons.find((ite) => ite?.value == it?.text)
                    if (it?.type == 'URL' && check?.type == 'DYNAMIC') {
                        return {
                            label: "Visit website",
                            status: true,
                            text: it?.text,
                            type: check?.type,
                            dynamic_Key: "",
                            display_name: check.feild_name,
                            url: it?.url,
                            example: {
                                header_text: it?.example[0]
                            },
                            buttonType: "URL"
                        }
                    }
                    if (it?.type == 'URL') {
                        return {
                            label: "Visit website",
                            status: true,
                            text: it?.text,
                            type: "STATIC",
                            dynamic_Key: "",
                            display_name: "",
                            url: "https://ticketsque.com",
                            example: {
                                header_text: ""
                            },
                            buttonType: "URL"
                        }
                    }

                })
                const check = button.find((it) => it?.label == "Chat with us")
                if (!check) {
                    button = [
                        ...button,
                        { label: "Chat with us", status: true, text: "Chat with us", code: "", buttonType: "QUICK_REPLY" }
                    ]
                }
                const checkDonate = button.find((it) => it?.label == "Donate Now")
                if (!checkDonate) {
                    button = [
                        ...button,
                        { label: "Donate Now", status: false, text: "Donate Now", code: "", buttonType: "QUICK_REPLY" }
                    ]
                }
            } else {
                button = [{
                    label: "Visit website", status: false, text: "Visit website", type: "STATIC", dynamic_Key: "", url: "https://ticketsque.com", example: {
                        header_text: "",
                    },
                    buttonType: "URL",
                    display_name: "",
                }, { label: "Chat with us", status: true, text: "Chat with us", code: "", buttonType: "QUICK_REPLY" },
                { label: "Donate Now", status: false, text: "Donate Now", code: "", buttonType: "QUICK_REPLY" }]
            }
            const footer = components.find((it) => it?.type == 'FOOTER')
            if (!header) {
                header = {
                    meta_type: "HEADER",
                    format: "NONE",
                    text: "",
                    example: {
                        type: "STATIC",
                        header_text: "",
                        header_handle: "",
                        dynamic_Key: "",
                        display_name: ""
                    }
                }
            } else {

                if (header?.format == 'IMAGE') {
                    header = {
                        meta_type: "HEADER",
                        format: header?.format,
                        example: {
                            type: "STATIC",
                            header_text: "",
                            header_handle: header?.example?.header_handle[0],
                            dynamic_Key: "",
                            display_name: ""
                        }
                    }
                }

            }
            if (body) {
                body = {
                    meta_type: "BODY",
                    text: body?.text,
                }
            }
            let matches = variableBody.map((it) => {
                const key = state?.template_feilds?.find((ite) => ite?._id == it?.feild_name)?._id
                return { key: `{{${it?.key_value}}}`, value: it?.fallback_value, type: it?.type, dynamic_Key: key || null, display_name: it?.value }
            })

            let vendorType = "all";
            let vendorId = "";
            if (vendor) {
                vendorType = "individual"
            }
            if (vendor) {
                vendorId = vendor?._id
            }

            return {
                ...state,
                template: category?._id,
                language: language?._id,
                meta_acc_id: meta_acc_id,
                name: name,
                selectedImage: header?.format != 'NONE' ? 'https://ticketsque-public.s3.ap-south-1.amazonaws.com/logo12092024.png' : "",
                header,
                body,
                bodyplaceholder: matches,
                footerText: footer?.text,
                visiteButton: button,
                template_id: meta_template_id,
                vendorId,
                vendorType,
                template_status: active
            }
        }

        default:
            return state
    }

}

const validateMessage = (message) => {
    if (message.length > 1024) {
        return "Message exceeds maximum length of 1024 characters.";
    }
    const variablePattern = /\{\{(\d+)\}\}/g;
    let matches = [...message.matchAll(variablePattern)].map((m) => parseInt(m[1]));
    if (matches.length > 0) {
        let sortedMatches = [...matches].sort((a, b) => a - b);
        for (let i = 0; i < sortedMatches.length; i++) {
            if (sortedMatches[i] !== i + 1) {
                return "Variable parameters are missing or not sequential.";
            }
        }
    }
    const totalWords = message.replace(/{{\d+}}/g, "").split(/\s+/).filter(Boolean).length; // Non-variable words
    if (matches.length > totalWords / 3) {
        return "The body text contains too many variable parameters relative to the message length. Each variable should have at least 3 words associated with it (3:1 ratio minimum)."

    }

    if (/\{\{.*[#\$%].*\}\}/.test(message)) {
        return "Variable parameters contain invalid special characters.";
    }
    // Ensure message template does not end with a variable
    if (message.trim().match(/\{\{\d+\}\}$/)) {
        return "Message template cannot end with a variable parameter.";
    }
    // Check for potentially abusive or threatening content
    const prohibitedPhrases = [
        "legal action",
        "publicly shame",
        "threaten",
    ];
    if (prohibitedPhrases.some((phrase) => message.toLowerCase().includes(phrase))) {
        return "Message contains potentially abusive or threatening content.";
    }

    return "";
};

const validateInput = (input) => {
    if (!input.includes("{{")) return null;

    const pattern = /(^|\s)\{\{[1]\}\}($|\s)|(^|\s)\{\{$/;

    if (!pattern.test(input)) {
        return 'This template contains variable parameters with incorrect formatting. Variable parameters must be whole numbers with two sets of curly brackets (for example, {{1}}).'
    }
    const matches = input.match(/\{\{\d+\}\}/g);

    if (matches && new Set(matches).size > 1) {
        return 'Multiple different placeholders are not allowed. Use only one type, such as {{1}}, throughout the text.';
    }
    if (matches && input.includes("{{}}")) {
        return "Invalid use of empty curly brackets. Once a numbered placeholder (e.g., {{1}}) is used, empty brackets {{}} are not allowed.";
    }
    return null
};

const extractPlaceholders = (input) => {
    const matches = input.match(/\{\{1\}\}/g);
    return matches || [];

};
function getNumberFromString(str) {
    const match = str.match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
}

export default function CreateCampaignTemplateDefault() {
    const { user } = useAuthContext()
    const location = useLocation()
    let isRead = location.state?.isreadOnly || false
    const navigate = useNavigate()
    const { template_feilds } = useCampaignTemplateContext();
    const { themeStretch } = useSettingsContext();
    const [state, dispatch] = useReducer(reducer, {
        vendorType: "all",
        meta_acc_id: "",
        name: "",
        phone_number: "",
        language: "",
        template: "",
        header: {
            meta_type: "HEADER",
            format: "NONE",
            text: "",
            example: {
                type: "STATIC",
                header_text: "",  // if we added variables 
                header_handle: "",
                dynamic_Key: "",
                display_name: ""
            }
        },
        body: {
            meta_type: "BODY",
            text: "Hello",
        },
        vendorId: "",
        template_feilds: [],
        footerText: "Send STOP to unsubscribe | Powered by ticketsque.com",
        bodyplaceholder: [],
        headerError: '',
        bodyError: "",
        assign_number: [],
        visiteButton: [
            {
                label: "Visit website", status: false, text: "Visit website", type: "STATIC", dynamic_Key: "", url: "https://ticketsque.com", example: {
                    header_text: "",  // if we added variables 
                },
                buttonType: "URL",
                display_name: ""
            },
            // { label: "Call Phone Number", status: false, text: "Call Phone Number", phone_number: "", buttonType: "PHONE_NUMBER" },
            // { label: "Copy offer code", status: false, text: "Copy offer code", code: "", buttonType: "COPY_CODE" },
            { label: "Chat with us", status: true, text: "Chat with us", code: "", buttonType: "QUICK_REPLY" },
            { label: "Donate Now", status: false, text: "Donate Now", code: "", buttonType: "QUICK_REPLY" },
        ],
        template_status: "0"
    })

    const [imagePath, setImagePath] = useState()
    const handleImageChange = async (event) => {
        const file = event.target.files[0];
        if (!file) return;
        const allowedTypes = ["image/png", "image/jpeg"];

        if (!allowedTypes.includes(file.type)) {
            notify("Only PNG and JPG images are allowed!");
            return;
        }
        if (file) {
            handleChangeValue('selectedImage', URL.createObjectURL(file)); // Preview ke liye
            setImagePath(file)
        }
        const formData = new FormData()
        formData.append('image', file)
        const url = `/service/campaign_service/v1/campaign/template/image_upload`
        const data = await postUploadImage(user, formData, url)
        if (data) {
            handleChangeValue('header.example.header_handle', data?.header_handle)
        }

    };

    const handleChangeValue = (type, payload) => {
        dispatch({ type, payload });
    };


    const generateOutput = (output, placeholders, value) => {
        if (placeholders && value) {
            placeholders.forEach((key) => {
                const escapedKey = key.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                output = output.replace(new RegExp(escapedKey, "g"), value || "");
            });
        }
        return output;
    };
    const generateOutput2 = (output, placeholders) => {
        if (placeholders.length) {
            placeholders.forEach((key) => {
                if (key?.value) {
                    const escapedKey = key?.key?.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
                    output = output.replace(new RegExp(escapedKey, "g"), key?.value || "");
                }
            });
        }
        output = output.replace(/\*(.*?)\*/g, "<b>$1</b>");
        output = output.replace(/\_(.*?)\_/g, "<i>$1</i>");
        return output;
    };

    const handleRemoveImage = () => {
        handleChangeValue('selectedImage', '')
        setImagePath();
        handleChangeValue('header.example.header_handle', '')
        document.getElementById("upload-image").value = "";

    }

    const prevTextRef = useRef("");
    const handleChange = (event) => {
        let value = event.target.value;
        let newText = value;
        const isBackspace = prevTextRef.current.length > value.length;
        if (!isBackspace && value.endsWith("{{")) {
            const variablePattern = /\{\{(\d+)\}\}/g;
            let matches = [...value.matchAll(variablePattern)].map((m) => parseInt(m[1]));
            let nextNumber = matches.length > 0 ? Math.max(...matches) + 1 : 1;
            newText = value + `${nextNumber}}}`;
        }
        handleChangeValue('bodyError', validateMessage(newText));
        handleChangeValue('body.text', newText);
        extractPlaceholdersForBody(newText)
        prevTextRef.current = newText;
    };
    const extractPlaceholdersForBody = (input) => {
        const matches = input.match(/\{\{[1-9]\}\}/g);
        const bodyplaceholder = state?.bodyplaceholder || []
        handleChangeValue('bodyplaceholder', matches?.map(match => {
            const check = bodyplaceholder.find((it) => it?.key == match)
            if (check) {
                return check
            }
            return { key: match, value: "", type: "STATIC", dynamic_Key: "", display_name: "" }
        }) || [])
    };
    const textAreaRef = useRef(null);
    const wrapTextWithAsterisks = (sign) => {
        const textArea = textAreaRef.current;
        const start = textArea.selectionStart;
        const end = textArea.selectionEnd;
        if (start === end) return;
        const selectedText = state?.body?.text.substring(start, end);
        const newText = state?.body?.text.substring(0, start) + `${sign}${selectedText}${sign}` + state?.body?.text.substring(end);
        handleChangeValue('body.text', newText);
        setTimeout(() => {
            textArea.focus();
            textArea.selectionStart = start;
            textArea.selectionEnd = end + 2;
        }, 0);
    };
    const [category, setCategory] = useState([])
    const [language, setLanguage] = useState([])
    useEffect(() => {
        const fetchData = async () => {
            const data = await getCampianCategory(user)
            setCategory(data.reverse())
            const response = await getCampianLanguages(user)
            setLanguage(response)
            if (!location.state) {
                handleChangeValue('template', data[0]?._id)
                handleChangeValue('language', response[0]?._id)
            }
        }

        fetchData()
    }, [])

    useEffect(() => {
        if (template_feilds) {
            handleChangeValue('template_feilds', template_feilds)
        }
    }, [template_feilds])

    const [loadingBtn, setLoadingBtn] = useState(false)
    const handleSubmit = async () => {
        try {
            const { meta_acc_id, name, language, template, header, body, bodyplaceholder, visiteButton, footerText, vendorId, phone_number, headerError, bodyError, template_id } = state
            const { text, example, format } = header
            if (!name.trim()) {
                return notify('Please select template name.')
            }
            if (!language) {
                return notify('Please select language.')
            }

            if (headerError) {
                return notify(headerError)
            }
            if (bodyError) {
                return notify(bodyError)
            }

            if (header?.format == 'TEXT' && example?.type == "DYNAMIC") {
                if (!example?.dynamic_Key?.trim()) {
                    return notify('Please select field name in the header section.')
                }
            }

            if (header?.format == 'IMAGE') {
                if (!example?.header_handle?.trim()) {
                    return notify('Please select image in the header section.')
                }
            }
            if (!body.text?.trim()) {
                return notify("Body is required.")
            }

            if (bodyplaceholder.length) {
                for (let i = 0; i < bodyplaceholder?.length; i++) {
                    const element = bodyplaceholder[i];

                    if (element?.type == 'DYNAMIC') {
                        if (!element?.dynamic_Key?.trim()) {
                            return notify(`Please select a field name in the body section for key: ${element?.key}.`);
                        }
                    }

                    if (element?.type == 'STATIC') {
                        if (!element?.display_name?.trim()) {
                            return notify(`Please fill the display name in the body section for key: ${element?.key}.`);
                        }
                    }

                    if (!element?.value?.trim()) {
                        return notify(`Please fill the example value in the body section for key: ${element?.key}.`);
                    }
                }
            }

            const buttons = visiteButton.filter((it) => it?.status)

            for (let i = 0; i < buttons.length; i++) {
                const element = buttons[i];

                if (element?.buttonType == 'URL') {
                    if (element?.type == 'DYNAMIC') {
                        if (!element?.example?.header_text.trim()) {
                            return notify('Please add sample for website url.');
                        }
                    }
                    if (element?.type == 'DYNAMIC') {
                        if (!element?.display_name.trim()) {
                            return notify('Please add display name for the button.');
                        }
                    }
                }

                if (element?.buttonType == "PHONE_NUMBER") {
                    if (!element?.phone_number) {
                        return notify('Please add phone number.');
                    }
                }

                if (element?.buttonType == "COPY_CODE") {
                    if (!element?.code) {
                        return notify('Please add Offer code.');
                    }
                }

                if (!element?.text?.trim()) {
                    return notify('Please add button text.');
                }
            }


            let variable = {
                header: [],
                body: [],
                button: []
            }
            if (header?.format == 'NONE') {
                variable = {
                    ...variable,
                    header: []
                }
            }
            if (header?.format == 'TEXT') {
                variable = {
                    header: extractPlaceholders(state?.header?.text)?.map((it) => {
                        return {
                            key_value: getNumberFromString(it) || null,
                            type: example?.type,
                            value: example?.display_name || null,
                            feild_name: example?.dynamic_Key || null,
                            fallback_value: example?.header_text
                        }
                    }),
                    ...variable,
                }
            }

            if (header?.format == 'IMAGE') {

                variable = {
                    ...variable,
                    header: [{
                        key_value: '1',
                        value: "Image",
                        type: "STATIC",
                        feild_name: null,
                        fallback_value: null
                    }],

                }
            }



            if (bodyplaceholder.length) {
                variable = {
                    ...variable,
                    body: bodyplaceholder.map((it) => {
                        return {
                            key_value: getNumberFromString(it?.key) || null,
                            type: it?.type,
                            value: it?.display_name || null,
                            feild_name: it?.dynamic_Key || null,
                            fallback_value: it?.value
                        }
                    })

                }

            }

            if (buttons.length) {
                variable = {
                    ...variable,
                    button: buttons.map((it) => {
                        return {
                            key_value: '1',
                            type: it?.type || null,
                            value: it?.text || null,
                            feild_name: it?.display_name || null,
                            fallback_value: it?.example?.header_text || null
                        }
                    })

                }

            }

            let componentHeader = {
                meta_type: "HEADER",
                format: format,

            }
            if (format == 'TEXT') {
                componentHeader = {
                    ...componentHeader,
                    text: text,
                    example: {
                        header_text: [
                            example?.header_text
                        ]
                    }

                }
            }
            if (format == "IMAGE") {
                componentHeader = {
                    ...componentHeader,
                    example: {
                        header_handle: [
                            example?.header_handle
                        ]
                    }

                }
            }
            if (format == 'NONE') {
                componentHeader = null
            }

            let componentBody = {
                meta_type: "BODY",
                text: body?.text
            }
            if (bodyplaceholder.length) {
                componentBody = {
                    ...componentBody,
                    example: {
                        body_text: [
                            [
                                ...bodyplaceholder.map((it) => it?.value)
                            ]
                        ]
                    }
                }

            }
            let componentFooter = {
                meta_type: "FOOTER",
                text: footerText
            }
            if (!footerText) {
                componentFooter = null
            }
            let componentButtons = {
                meta_type: "BUTTONS",
                buttons: buttons.length ? buttons.map((it) => {
                    if (it?.buttonType == 'URL' && it?.type == 'DYNAMIC') {
                        return {
                            type: "URL",
                            text: it?.text,
                            url: it?.url,
                            example: [
                                it?.example?.header_text
                            ]
                        }
                    }
                    if (it?.buttonType == 'URL') {
                        return {
                            type: "URL",
                            text: it?.text,
                            url: it?.url,
                        }
                    }
                    if (it?.buttonType == 'PHONE_NUMBER') {
                        return {
                            type: "PHONE_NUMBER",
                            text: it?.text,
                            phone_number: it?.phone_number,
                        }
                    }
                    if (it?.buttonType == 'COPY_CODE') {
                        return {
                            type: "CODE",
                            example: it?.code,
                        }
                    }
                    if (it?.buttonType == 'QUICK_REPLY') {
                        return {
                            type: "QUICK_REPLY",
                            text: "Chat with us",
                        }
                    }
                }) : []
            }
            if (!buttons.length) {
                componentButtons = null

            }

            let data = {
                name: name,
                language: language,
                category: template,
                variables: JSON.stringify(variable),
                components: [
                    componentHeader,
                    componentBody,
                    componentFooter,
                    componentButtons
                ].filter(Boolean),
                template_id: template_id,
            }

            // console.log(data);
            let response
            setLoadingBtn(true)
            if (location?.state) {
                response = await updateTemplate(user, data)

            } else {
                response = await createCampaignTemplateDefault(user, data)
            }
            if (response) {
                navigate(-1)
                notify(response?.message, "success")
            }
        } catch (err) {
            console.log(err);

        } finally {
            setLoadingBtn(false)
        }

    }



    useEffect(() => {
        const fetchData = async () => {
            const data = await getCampianAssignVendorGroups(user, 0, 100000, "", "created", state?.meta_acc_id)
            handleChangeValue('assign_number', data)

        }
        if (state?.meta_acc_id) {
            fetchData()
        }
    }, [state?.meta_acc_id])
    const [loadingBack, setLoadingBack] = useState(location.state ? true : false)
    useEffect(() => {
        if (location?.state && category?.length && language?.length && template_feilds?.length) {
            handleChangeValue('edit', location.state)
            setLoadingBack(false)
        }
    }, [location.state, category, language, template_feilds])
    const { open: isOpen, handleCloseModal, handleOpenModal } = useModalControl()
    const emojiPickerRef = useRef(null);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target)) {
                handleCloseModal();
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);


    // console.log(state, "=========>>>>>>>");
    let isEdit = location.state ? true : false
    return (
        <div style={{ position: "relative" }}  >
            {loadingBack && <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1000000 }}
                open={loadingBack}
            >
                <CircularProgress color="inherit" />
            </Backdrop>}
            <Container maxWidth={themeStretch ? false : 'lg'}>
                <Stack spacing={2} direction="row" alignItems="center" mb="10px" >
                    <IconButton color="primary" onClick={() => navigate("/dashboard/campaign/template", { state: location?.state?.isreadOnly })}>
                        <ArrowBackIcon sx={{ fontSize: "30px" }} />
                    </IconButton>
                    <Typography variant="h3">
                        {
                            location?.state ?
                                "Update Template" : "Create Default New Template"
                        }

                    </Typography>
                </Stack>

                <Grid container >
                    <Grid item xs={12} md={8}>
                        <Grid container spacing={1} alignItems="center">
                            {/* {location?.state && <Grid item xs={12} >
                                <Paper sx={{ display: "flex", padding: "10px", flexDirection: "column" }} >
                                    <Typography variant='h6'>Status</Typography>
                                    <FormControl>
                                        <RadioGroup
                                            row
                                            aria-labelledby="demo-row-radio-buttons-group-label"
                                            name="row-radio-buttons-group"
                                            onChange={async (e) => {
                                                handleChangeValue('template_status', e.target.value)
                                                if (location?.state) {
                                                    const data = await updateTemplateStatus(user, { status: e.target.value, template_id: location.state.meta_template_id })
                                                    if (data) {
                                                        notify("Status Update successfully.", "success")
                                                    }
                                                }
                                            }}
                                            value={state.template_status}
                                        >
                                            <FormControlLabel value="0" control={<Radio />} label="Active" />
                                            <FormControlLabel value="1" control={<Radio />} label="In Active" />

                                        </RadioGroup>
                                    </FormControl>
                                </Paper>
                            </Grid>} */}
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">

                                        <Grid item xs={12} >
                                            <Stack spacing={1} marginBottom="4px">
                                                <Typography variant="h6">Set up your template <sup style={{ color: "red" }}>*</sup></Typography>
                                                <FormControl>
                                                    <RadioGroup
                                                        sx={{ display: 'flex', flexDirection: 'row' }}
                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                        name="controlled-radio-buttons-group"
                                                        value={state?.template}
                                                        size="small"

                                                        onChange={(e) => handleChangeValue('template', e.target.value)}
                                                    >
                                                        {
                                                            category?.map((it) => {
                                                                return (

                                                                    <FormControlLabel key={it?._id} value={it?._id} control={<Radio disabled={isEdit} />} label={it?.handle} />
                                                                )
                                                            })
                                                        }
                                                    </RadioGroup>
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <Stack spacing={1} marginBottom="4px" direction="row" alignItems="self-start">
                                                <Box sx={{ padding: "8px 12px", background: "#4dbba6", borderRadius: "6px" }}>
                                                    <CampaignIcon sx={{ fontSize: "30px" }} />
                                                </Box>
                                                <Stack spacing={.5}>
                                                    <Stack direction="row" gap={1}>
                                                        <Typography variant='body1'>{state?.name ? state?.name : 'your_template_name'} </Typography>
                                                        <Typography variant='body1'>|</Typography>
                                                        <Typography variant='body1'>English</Typography>
                                                    </Stack>
                                                    <Stack direction="row" gap={1}>
                                                        <Typography variant="caption" sx={{ color: "#ffffff50" }}>
                                                            {
                                                                category?.find((it) => it?._id == state?.template)?.handle
                                                            }
                                                        </Typography>
                                                        <Typography variant="caption" sx={{ color: "#ffffff50" }}>|</Typography>
                                                        <Typography variant="caption" sx={{ color: "#ffffff50" }}>Custom</Typography>
                                                    </Stack>
                                                </Stack>


                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">

                                        <Grid item xs={12} >
                                            <Typography variant='h6'>Template name and language <sup style={{ color: "red" }}>*</sup></Typography>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Stack spacing={1} marginBottom="4px">
                                                <Typography variant="body1">Templete Name <sup style={{ color: "red" }}>*</sup></Typography>
                                                <TextField fullWidth placeholder='Enter a templete name.'
                                                    value={state?.name}
                                                    onChange={(e) => handleChangeValue('name', e.target.value)}
                                                    inputProps={{ maxLength: 512 }}
                                                    disabled={isEdit}
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position="start">
                                                                <Typography sx={{ fontSize: "14px" }}>
                                                                    {state?.name?.length}/512
                                                                </Typography>
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} md={6}>
                                            <Stack spacing={1} marginBottom="4px">
                                                <Typography variant="body1">Select language <sup style={{ color: "red" }}>*</sup></Typography>
                                                <FormControl fullWidth>
                                                    <InputLabel id="demo-simple-select-label">Select language</InputLabel>
                                                    <Select fullWidth placeholder='Enter a templete name.'
                                                        value={state?.language}
                                                        onChange={(e) => handleChangeValue('language', e.target.value)}
                                                        select
                                                        // disabled={isEdit}
                                                        disabled
                                                        label="Select language"
                                                    >
                                                        {
                                                            language?.map((it) => {
                                                                return (

                                                                    <MenuItem value={it?._id}>{it?.name}</MenuItem>
                                                                )
                                                            })
                                                        }
                                                    </Select>
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">

                                        <Grid item xs={12} >
                                            <Typography variant='h6'>Content <sup style={{ color: "red" }}>*</sup></Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <Stack spacing={1} marginBottom="4px">
                                                <Typography variant="body1">Header (Optional)</Typography>
                                                <FormControl>
                                                    <RadioGroup
                                                        sx={{ display: 'flex', flexDirection: 'row' }}
                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                        name="controlled-radio-buttons-group"
                                                        value={state?.header?.format}
                                                        size="small"
                                                        onChange={(e) => handleChangeValue('header.format', e.target.value)}
                                                    >
                                                        <FormControlLabel value="NONE" control={<Radio disabled={isRead} />} label="None" />
                                                        {/* <FormControlLabel value="TEXT" control={<Radio />} label="Text" /> */}
                                                        <FormControlLabel
                                                            value="IMAGE"
                                                            control={<Radio disabled={isRead} />}
                                                            label="Image"
                                                        />
                                                    </RadioGroup>
                                                </FormControl>
                                            </Stack>
                                        </Grid>
                                        {state?.header?.format === 'TEXT' && <Grid item xs={12} >
                                            <TextField placeholder='Enter text in English' fullWidth
                                                value={state?.header?.text}
                                                onChange={(e) => handleChangeValue('header.text', e.target.value)}
                                                inputProps={{ maxLength: 60 }}
                                                disabled={isRead}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="start">
                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                {state?.header?.text?.length}/60
                                                            </Typography>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                                error={!!state?.headerError}
                                                // error={true}
                                                helperText={state?.headerError}
                                            />
                                            <Stack direction="row" justifyContent="flex-end" marginTop="10px">
                                                <Button startIcon={<AddIcon />} disabled={state?.header?.text?.includes('{{1}}') || isRead} variant="contained" onClick={() => handleChangeValue('header.text.variable')}>Add Variable</Button>
                                            </Stack>

                                            {(extractPlaceholders(state?.header?.text).length > 0 && !state?.headerError) && extractPlaceholders(state?.header?.text).map((it) => {
                                                return (
                                                    <Stack key={it}>
                                                        <Typography variant="h6">Samples for header content</Typography>
                                                        <FormControl>
                                                            <RadioGroup
                                                                sx={{ display: 'flex', flexDirection: 'row' }}
                                                                aria-labelledby="demo-controlled-radio-buttons-group"
                                                                name="controlled-radio-buttons-group"
                                                                value={state?.header.example?.type}
                                                                size="small"
                                                                onChange={(e) => handleChangeValue('header.example?.type', e.target.value)}
                                                            >
                                                                <FormControlLabel value="STATIC" control={<Radio disabled={isRead} />} label="Static" />
                                                                <FormControlLabel value="DYNAMIC" control={<Radio disabled={isRead} />} label="Dynamic" />
                                                            </RadioGroup>
                                                        </FormControl>
                                                        {state?.header.example?.type == 'DYNAMIC' && <>
                                                            <Typography variant="h6">Select Field Name</Typography>

                                                            <FormControl>
                                                                <RadioGroup
                                                                    sx={{ display: 'flex', flexDirection: 'row' }}
                                                                    aria-labelledby="demo-controlled-radio-buttons-group"
                                                                    name="controlled-radio-buttons-group"
                                                                    value={state?.header.example?.dynamic_Key}
                                                                    size="small"
                                                                    onChange={(e) => handleChangeValue('header.example?.dynamic_Key', e.target.value)}
                                                                >
                                                                    {
                                                                        template_feilds?.map((it) => {
                                                                            return (
                                                                                <FormControlLabel value={it?._id} key={it?._id} control={<Radio disabled={isRead} />} label={it?.name} />
                                                                            )
                                                                        })
                                                                    }
                                                                </RadioGroup>
                                                            </FormControl>
                                                        </>
                                                        }
                                                        {state?.header.example?.type == 'STATIC' && <Box sx={{ margin: "0 0 10px 0px" }}>
                                                            <Typography variant="body2">Display Name</Typography>

                                                            <TextField
                                                                fullWidth
                                                                value={state?.header.example?.display_name}
                                                                onChange={(e) => handleChangeValue('header.example?.display_name', e.target.value)}
                                                                placeholder="Enter display name."
                                                                disabled={isRead}
                                                            />
                                                        </Box>
                                                        }

                                                        <Stack direction="row" alignItems="center" gap={1}>
                                                            <Typography variant="body2">{it}</Typography>
                                                            <TextField fullWidth placeholder={`Enter content for ${it}`}
                                                                value={state?.header?.example?.header_text}
                                                                onChange={(e) => handleChangeValue('header.example.header_text', e.target.value)}
                                                                disabled={isRead}
                                                            />
                                                        </Stack>

                                                    </Stack>
                                                )
                                            })}
                                        </Grid>}
                                        {state?.header?.format === 'IMAGE' && <Grid item xs={12} >

                                            <Stack direction="row" gap={1} alignItems="center">
                                                <Typography>Image</Typography>

                                                {!state?.selectedImage ? <label htmlFor="upload-image">
                                                    <Button startIcon={<CropOriginalIcon />} variant="contained" component="span" disabled={isRead}>
                                                        Choose JPG or PNG file
                                                    </Button>
                                                </label> : <Stack direction="row" alignItems="center" gap="5px" sx={{ padding: "0px 15px", border: "1px solid lightGrey", borderRadius: "6px" }}>
                                                    <img src={state?.selectedImage} alt="Selected" width="30" />
                                                    <Typography sx={{ fontSize: "14px" }} variant="caption">{imagePath?.name || 'Sample Image'}</Typography>
                                                    <IconButton onClick={() => handleRemoveImage()} disabled={isRead}>
                                                        <CloseIcon />
                                                    </IconButton>
                                                </Stack>}

                                                <input
                                                    type="file"
                                                    accept="image/png, image/jpeg"
                                                    style={{ display: "none" }}
                                                    id="upload-image"
                                                    disabled={isRead}
                                                    onChange={handleImageChange}
                                                />
                                            </Stack>


                                        </Grid>}
                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">

                                        <Grid item xs={12} >
                                            <Typography variant='h6'>Body <sup style={{ color: "red" }}>*</sup></Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <TextField multiline rows={6} placeholder='Enter text in English' fullWidth inputProps={{ maxLength: 1024 }}
                                                onChange={handleChange}
                                                value={state?.body?.text}
                                                error={state?.bodyError}
                                                helperText={state?.bodyError}
                                                inputRef={textAreaRef}
                                                disabled={isRead}
                                                id={`textField-1`}
                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="end" sx={{ position: "relative", top: "-65px" }} >
                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                {state?.body?.text?.length}/1024
                                                            </Typography>
                                                        </InputAdornment>
                                                    ),
                                                }}

                                            />
                                        </Grid>
                                        <Grid item xs={12} >
                                            <Stack direction="row" justifyContent="flex-end">
                                                <IconButton onClick={() => wrapTextWithAsterisks('*')} disabled={isRead}>
                                                    <FormatBoldIcon />
                                                </IconButton>
                                                <IconButton onClick={() => wrapTextWithAsterisks('_')} disabled={isRead}>
                                                    <FormatItalicIcon />
                                                </IconButton>
                                                <IconButton onClick={() => handleOpenModal()} disabled={isRead}>
                                                    <EmojiEmotions />
                                                </IconButton>
                                                <Button startIcon={<AddIcon />} disabled={isRead} variant="contained" onClick={() => handleChangeValue('body.text.variable')}>Add Variable</Button>

                                            </Stack>
                                            <Stack mt={2} ref={emojiPickerRef}>
                                                <EmojiPicker
                                                    width="100%"
                                                    open={isOpen}
                                                    onEmojiClick={(emoji) => {
                                                        const textField = document.getElementById(`textField-1`);
                                                        const currentValue = textField.value;
                                                        const selectionStart = textField.selectionStart;
                                                        const selectionEnd = textField.selectionEnd;
                                                        const newValue =
                                                            currentValue.substring(0, selectionStart) +
                                                            emoji.emoji +
                                                            currentValue.substring(selectionEnd);
                                                        textField.value = newValue;
                                                        textField.focus();
                                                        textField.setSelectionRange(
                                                            selectionStart + emoji.emoji.length,
                                                            selectionStart + emoji.emoji.length
                                                        );
                                                        handleChangeValue('body.text', newValue);

                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item xs={12} >
                                            {
                                                ((!state?.bodyError && state?.bodyplaceholder?.length > 0) && state?.bodyplaceholder?.map((it) => {
                                                    return (
                                                        <Paper key={it?.key} sx={{ padding: "10px", border: "1px solid #ffffff50", marginBottom: "10px" }}>
                                                            <Stack marginTop="5px">
                                                                <Typography variant="h6">Samples for body content</Typography>
                                                                <FormControl>
                                                                    <RadioGroup
                                                                        sx={{ display: 'flex', flexDirection: 'row' }}
                                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                                        name="controlled-radio-buttons-group"
                                                                        value={it?.type}
                                                                        size="small"

                                                                        onChange={(e) => handleChangeValue('bodyplaceholder.type', { key: it?.key, type: e.target.value })}
                                                                    >
                                                                        <FormControlLabel value="STATIC" control={<Radio disabled={isRead} />} label="Static" />
                                                                        <FormControlLabel value="DYNAMIC" control={<Radio disabled={isRead} />} label="Dynamic" />
                                                                    </RadioGroup>
                                                                </FormControl>
                                                                {it?.type == 'DYNAMIC' && <>
                                                                    <Typography variant="h6">Select Field Name</Typography>
                                                                    <FormControl>
                                                                        <RadioGroup
                                                                            sx={{ display: 'flex', flexDirection: 'row' }}
                                                                            aria-labelledby="demo-controlled-radio-buttons-group"
                                                                            name="controlled-radio-buttons-group"
                                                                            size="small"
                                                                            value={it?.dynamic_Key}
                                                                            onChange={(e) => handleChangeValue('bodyplaceholder.dynamic_Key', { key: it?.key, dynamic_Key: e.target.value })}
                                                                        >
                                                                            {
                                                                                template_feilds?.map((it) => {
                                                                                    return (
                                                                                        <FormControlLabel value={it?._id} key={it?._id} control={<Radio disabled={isRead} />} label={it?.name} />
                                                                                    )
                                                                                })
                                                                            }
                                                                        </RadioGroup>
                                                                    </FormControl>
                                                                </>}
                                                                {it?.type == 'STATIC' && <Box sx={{ margin: "0 0 10px 0px" }}>
                                                                    <Typography variant="body2">Display Name</Typography>

                                                                    <TextField
                                                                        fullWidth
                                                                        value={it?.display_name}
                                                                        onChange={(e) => handleChangeValue('bodyplaceholder.display_name', { key: it?.key, display_name: e.target.value })}
                                                                        placeholder="Enter display name."
                                                                        disabled={isRead}
                                                                    />
                                                                </Box>
                                                                }
                                                                <Stack direction="row" alignItems="center" gap={1}>
                                                                    <Typography variant="body2">{it?.key}</Typography>
                                                                    <TextField fullWidth placeholder={`Enter content for ${it?.key}`}
                                                                        value={it?.value}
                                                                        disabled={isRead || it?.type == 'DYNAMIC'}

                                                                        onChange={(e) => handleChangeValue('bodyplaceholder.value', { key: it?.key, value: e.target.value })}
                                                                    />
                                                                </Stack>

                                                            </Stack>
                                                        </Paper>
                                                    )
                                                }))
                                            }
                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item xs={12} >
                                            <Typography variant='h6'>Footer (Optional)</Typography>
                                        </Grid>
                                        <Grid item xs={12} >
                                            <TextField placeholder='Enter text in English' fullWidth
                                                value={state?.footerText}
                                                onChange={(e) => handleChangeValue('footerText', e.target.value)}
                                                inputProps={{ maxLength: 60 }}
                                                disabled

                                                InputProps={{
                                                    endAdornment: (
                                                        <InputAdornment position="start">
                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                {state?.footerText?.length}/60
                                                            </Typography>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>
                            <Grid item xs={12} >
                                <Paper sx={{ padding: "10px" }}>
                                    <Grid container spacing={1} alignItems="center">
                                        <Grid item xs={12} >
                                            <Typography variant='h6'>Buttons (Optional)</Typography>
                                            <Typography variant="caption" sx={{ fontWeight: "normal" }}>Create buttons that let customers respond to your message or take action. You can add up to one buttons.
                                                {/* If you add more than three buttons, they will appear in a list. */}
                                            </Typography>
                                        </Grid>
                                        <Grid item xs={12} >

                                            <FormGroup row>
                                                {
                                                    state?.visiteButton?.map((it, index) => {
                                                        return (
                                                            <FormControlLabel key={it?.label} control={<Checkbox disabled={isRead || it?.label == "Chat with us"} checked={it?.status} onChange={(e) => handleChangeValue('visiteButton', { index, checked: e.target.checked })} />} label={it?.label} />
                                                        )
                                                    })
                                                }
                                            </FormGroup>


                                        </Grid>
                                        <Grid item xs={12} >

                                            <Stack spacing={1}>
                                                {
                                                    state?.visiteButton?.map((ite, index) => {
                                                        if (!ite?.status) {
                                                            return
                                                        }
                                                        if (ite?.label == "Chat with us" || ite?.label == "Donate Now") {
                                                            return
                                                        }
                                                        return (
                                                            <Paper sx={{ display: "flex", border: "1px solid #ffffff50", padding: "10px", flexDirection: "column" }} key={ite?.label}>
                                                                {['Visit website'].includes(ite?.label) && <FormControl>
                                                                    <RadioGroup
                                                                        sx={{ display: 'flex', flexDirection: 'row' }}
                                                                        aria-labelledby="demo-controlled-radio-buttons-group"
                                                                        name="controlled-radio-buttons-group"
                                                                        value={ite?.type}
                                                                        size="small"
                                                                        row
                                                                        onChange={(e) => handleChangeValue('visiteButton.type', { index, type: e.target.value })}
                                                                    >
                                                                        <FormControlLabel value="STATIC" control={<Radio disabled={isRead} />} label="Static" />
                                                                        <FormControlLabel value="DYNAMIC" control={<Radio disabled={isRead} />} label="Dynamic" />
                                                                    </RadioGroup>
                                                                </FormControl>}
                                                                <Stack direction="row" gap={1} mb="10px">
                                                                    <CustomInput
                                                                        label="Button text"
                                                                        input={
                                                                            <TextField size='small' disabled={ite?.label == 'Copy offer code' || ite?.type == 'STATIC'} fullWidth placeholder='Enter text.'
                                                                                value={ite?.text}

                                                                                onChange={(e) => {
                                                                                    handleChangeValue('visiteButton.text', { index, text: e.target.value })
                                                                                    if (e.target.value == "Visit website") {
                                                                                        handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/{{1}}" })
                                                                                    } else if (e.target.value == "Event Link") {
                                                                                        handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/events/{{1}}" })
                                                                                    } else if (e.target.value == "RSVP") {
                                                                                        handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/rsvp?phoneNumber={{1}}" })
                                                                                    } else if (e.target.value == "WhatsApp") {
                                                                                        handleChangeValue('visiteButton.url', { index, url: "https://ticketsque.com/rsvp?wattsapp={{1}}" })
                                                                                    }
                                                                                }}
                                                                                inputProps={{ maxLength: 25 }}
                                                                                select
                                                                            >
                                                                                <MenuItem value="Visit website">Visit website</MenuItem>
                                                                                <MenuItem value="Event Link">Event Link</MenuItem>
                                                                                <MenuItem value="RSVP">RSVP</MenuItem>
                                                                                <MenuItem value="WhatsApp">WhatsApp</MenuItem>
                                                                            </TextField>
                                                                        }
                                                                    />


                                                                    {['Visit website'].includes(ite?.label) && <CustomInput
                                                                        label="Website URL"
                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter text.'
                                                                                inputProps={{ maxLength: 2000 }}
                                                                                value={ite?.url}
                                                                                disabled

                                                                                onChange={(e) => handleChangeValue('visiteButton.url', { index, url: e.target.value })}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.url?.length}/2000
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        }
                                                                    />}
                                                                    {['Copy offer code'].includes(ite?.label) && <CustomInput
                                                                        label="Offer code"
                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter code.'
                                                                                inputProps={{ maxLength: 15 }}
                                                                                value={ite?.code}
                                                                                disabled={isRead}
                                                                                onChange={(e) => handleChangeValue('visiteButton.code', { index, code: e.target.value })}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.code?.length}/15
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        }
                                                                    />}
                                                                    {!['Visit website', 'Copy offer code'].includes(ite?.label) && <CustomInput
                                                                        label="Phone Number"

                                                                        input={
                                                                            <TextField size='small' fullWidth placeholder='Enter number.'
                                                                                value={ite?.phone_number}
                                                                                onChange={(e) => handleChangeValue('visiteButton.phone_number', { index, phone_number: e.target.value })}
                                                                                inputProps={{ maxLength: 20 }}
                                                                                disabled={isRead}
                                                                                InputProps={{
                                                                                    endAdornment: (
                                                                                        <InputAdornment position="end" >
                                                                                            <Typography sx={{ fontSize: "14px" }}>
                                                                                                {ite?.phone_number?.length}/20
                                                                                            </Typography>
                                                                                        </InputAdornment>
                                                                                    ),
                                                                                }}
                                                                            />
                                                                        }
                                                                    />}
                                                                </Stack>
                                                                {ite?.type == 'DYNAMIC' && <CustomInput
                                                                    label="Display Name"
                                                                    input={
                                                                        <Box sx={{ margin: "0 0 10px 0px" }}>
                                                                            <TextField
                                                                                fullWidth
                                                                                value={ite?.display_name}
                                                                                disabled={isRead}
                                                                                // onChange={(e) => handleChangeValue('bodyplaceholder.display_name', { key: it?.key, display_name: e.target.value })}
                                                                                onChange={(e) => {
                                                                                    handleChangeValue('visiteButton.display_name', { index, text: e.target.value });

                                                                                }}
                                                                                placeholder="Enter display name."
                                                                            />
                                                                        </Box>

                                                                    }
                                                                />}
                                                                {ite?.type == 'DYNAMIC' && <Stack direction="row" alignItems="center" gap={1} marginTop="10px">
                                                                    <Typography>{`{{1}}`}</Typography>
                                                                    <TextField
                                                                        placeholder='Enter text in English'
                                                                        size='small'
                                                                        value={ite?.example?.header_text}
                                                                        onChange={(e) => handleChangeValue('visiteButton.example.header_text', { index, header_text: e.target.value })}
                                                                        fullWidth
                                                                        disabled={isRead}
                                                                    />
                                                                </Stack>}
                                                            </Paper>
                                                        )
                                                    })
                                                }
                                            </Stack>


                                        </Grid>

                                    </Grid>
                                </Paper>
                            </Grid>

                        </Grid>
                    </Grid>

                    <Grid xs={12} md={4} sx={{ position: "sticky", top: 0 }}>
                        <Paper sx={{ margin: "10px", position: "sticky", top: 70 }}>
                            <Box sx={{ background: "white", color: "black", padding: "10px" }}>
                                <Typography variant="h6">Template preview</Typography>
                            </Box>
                            <Box sx={{ background: "#ffffff38", padding: "20px 15px", display: "flex", flexDirection: "column" }}>
                                <Box sx={{
                                    position: "relative",
                                    background: "white",
                                    color: "black",
                                    borderRadius: "6px",
                                    borderTopLeftRadius: "0",
                                    maxWidth: "250px",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.15)",
                                    "::after": {
                                        content: '""',
                                        position: "absolute",
                                        top: 0,
                                        left: "-8px",
                                        width: 0,
                                        height: 0,
                                        borderTop: "10px solid white",
                                        borderLeft: "10px solid transparent",
                                    },
                                }}>
                                    <Box sx={{ padding: "10px 15px", }}>
                                        {(state?.header?.text && state?.header?.format === 'TEXT') && <Typography variant='h6' sx={{ fontSize: "14px !important", wordBreak: "break-all" }}>
                                            {generateOutput(state?.header?.text, extractPlaceholders(state?.header?.text), state?.header?.example?.header_text)}
                                        </Typography>}
                                        {(state?.selectedImage && state?.header?.format === 'IMAGE') && (
                                            <div style={{ width: "100%", height: "auto", maxHeight: "200px", overflow: "hidden", marginBottom: "10px" }}>
                                                <img src={state?.selectedImage} alt="Selected" width="100%" height="100%" />
                                            </div>
                                        )}
                                        <Typography sx={{
                                            fontSize: "12px !important",
                                            whiteSpace: "pre-wrap",
                                        }} dangerouslySetInnerHTML={{ __html: generateOutput2(state?.body?.text, state?.bodyplaceholder) }} />
                                        {state?.footerText && <Typography sx={{ fontSize: "12px !important", color: "grey", wordBreak: "break-all" }} >
                                            {state?.footerText}
                                        </Typography>}


                                        <Typography sx={{ fontSize: "10px", color: "gray", textAlign: "right", marginTop: "5px" }}>
                                            {dayjs().format('hh:mm')}
                                        </Typography>
                                    </Box>
                                    {state?.visiteButton?.filter((it) => it?.status).length > 0 && state?.visiteButton?.filter((it) => it?.status).map((it) => {
                                        return (
                                            <Typography sx={{ fontSize: "12px !important", color: "grey", wordBreak: "break-all", padding: "8px 0px", background: "white", maxWidth: "250px", borderTop: "1px solid lightGrey", textAlign: "center", display: "flex", alignItems: "center", justifyContent: "center", gap: "5px" }} color="primary" key={it?.text} >
                                                {
                                                    it?.label == 'Visit website' ?
                                                        <LaunchIcon /> : it?.label == 'Copy offer code' ?
                                                            <ContentCopyIcon /> : it?.label == 'Call Phone Number' ? <CallIcon /> :
                                                                it?.label == 'Chat with us'
                                                                    ? <ReplyIcon /> : ""
                                                }  {it?.text}
                                            </Typography>
                                        )
                                    })}
                                </Box>

                            </Box>


                        </Paper>

                    </Grid>


                </Grid>
                <Stack direction="row" gap="10px" marginTop="20px">
                    <LoadingButton loading={loadingBtn} disabled={loadingBtn || isRead} variant="contained" onClick={handleSubmit}>Submit</LoadingButton>
                    <Button variant="outlined" onClick={() => navigate("/dashboard/campaign/template", { state: location?.state?.isreadOnly })} >Cancel</Button>
                </Stack>
            </Container >
        </div >
    )
}
